/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_footer__magazine_button = /** @type {(inputs: {}) => string} */ () => {
	return `Das Info-Magazin ViaMichelin durchsuchen`
};

const en_footer__magazine_button = /** @type {(inputs: {}) => string} */ () => {
	return `Browse ViaMichelin Magazine`
};

const es_footer__magazine_button = /** @type {(inputs: {}) => string} */ () => {
	return `Navegar por el ViaMichelin Magazine`
};

const fr_footer__magazine_button = /** @type {(inputs: {}) => string} */ () => {
	return `Parcourir le Magazine ViaMichelin`
};

const it_footer__magazine_button = /** @type {(inputs: {}) => string} */ () => {
	return `Sfoglia il ViaMichelin Magazine`
};

const nl_footer__magazine_button = /** @type {(inputs: {}) => string} */ () => {
	return `Bladeren op ViaMichelin Magazine`
};

const pt_footer__magazine_button = /** @type {(inputs: {}) => string} */ () => {
	return `Procurar na revista ViaMichelin`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer__magazine_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer__magazine_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer__magazine_button", locale)
	if (locale === "de") return de_footer__magazine_button(inputs)
	if (locale === "en") return en_footer__magazine_button(inputs)
	if (locale === "es") return es_footer__magazine_button(inputs)
	if (locale === "fr") return fr_footer__magazine_button(inputs)
	if (locale === "it") return it_footer__magazine_button(inputs)
	if (locale === "nl") return nl_footer__magazine_button(inputs)
	return pt_footer__magazine_button(inputs)
};